import dashboardHR from './dashboard';
import menuAboutHR from './menuAbout';
import labelsHR from './labels';
import releasesHR from './releases';
import artistsHR from './artists';
import artistsWishlistHR from './artistsWishlist';
import profileHR from './profile';
import musicLinksHR from './musicLinks';
import linkLandingPagesHR from './linkLandingPages';
import masteringHR from './mastering';
import featureHR from './feature';
import accountingHR from './accounting';
import paymentMethodsHR from './paymentMethods';
import purchaseHistoryHR from './purchaseHistory';
import trendsHR from './trends';
import earningsDrilldownHR from './earningsDrilldown';
import invoicesHR from './invoices';
import statementsHR from './statements';
import subuserStatementsHR from './subuserStatements';
import userDataFormHR from './userDataForm';
import creditsHR from './credits';
import disputeClaimsHR from './disputeClaims';
import musicLinkUrlPartsHR from './musicLinkUrlParts';
import subscriptionHR from './subscription';
import twoFactorAuthHR from './twoFactorAuth';
import generalHR from './general';
import routerHR from './router';
import escrowWalletHR from './escrowWallet';
import subUsersHR from './subUsers';
import tokensHR from './tokens';
import tracksHR from './tracks';
import acrAlertHR from './acrAlert';
import qcNoteHR from './qcNote';
import flaggedContentHR from './flaggedContent';
import deliveryConfirmationHR from './deliveryConfirmation';
import preScanHR from './preScan';
import accessKeysHR from './accessKeys';
import announcementsHR from './announcements';

const translationHR = {
    'router': routerHR,
    'general': generalHR,
    'dashboard': dashboardHR,
    'menuAbout': menuAboutHR,
    'labels': labelsHR,
    'artists': artistsHR,
    'artistsWishlist': artistsWishlistHR,
    'releases': releasesHR,
    'tracks': tracksHR,
    'profile': profileHR,
    'musicLinks': musicLinksHR,
    'musicLinkUrlParts': musicLinkUrlPartsHR,
    'linkLandingPages': linkLandingPagesHR,
    'mastering': masteringHR,
    'feature': featureHR,
    'accounting': accountingHR,
    'paymentMethods': paymentMethodsHR,
    'purchaseHistory': purchaseHistoryHR,
    'trends': trendsHR,
    'earningsDrilldown': earningsDrilldownHR,
    'invoices': invoicesHR,
    'statements': statementsHR,
    'subuserStatements': subuserStatementsHR,
    'credits': creditsHR,
    'userDataForm': userDataFormHR,
    'disputeClaims': disputeClaimsHR,
    'subscription': subscriptionHR,
    'twoFactorAuth': twoFactorAuthHR,
    'escrowWallet': escrowWalletHR,
    'subUsers': subUsersHR,
    'tokens': tokensHR,
    'acrAlert': acrAlertHR,
    'qcNote': qcNoteHR,
    'flaggedContent': flaggedContentHR,
    'deliveryConfirmation': deliveryConfirmationHR,
    'preScan': preScanHR,
    'accessKeys': accessKeysHR,
    'announcements': announcementsHR,
};

export default translationHR;
